<template>
    <div>
        <input autofocus v-model="search" @keyup="getSortedItem" placeholder="Rechercher" type="text" class="styledInput search">
        <div class="item-list">
            <div class="item-item" v-for="item in sortedItems" :key="item._id">
                <button class="close-btn" @click="removeItem(item._id)"><font-awesome-icon icon="times"></font-awesome-icon></button>
                <div class="logo" v-if="item.logo !== '' && item.logo != null"><img :src="imgURL + '/brands/' + item.logo" alt="product image"></div>
                <p>{{ item.name }}</p>
                <div class="actions">
                    <button class="green-btn" @click="itemSelect(item)"><font-awesome-icon icon="pen"></font-awesome-icon></button>
                    <a target="_blank" :href="item.website" :disabled="!item.website" class="green-btn"><font-awesome-icon icon="globe"></font-awesome-icon></a>
                </div>
            </div>
        </div>
        <BrandPagination :currentPage=currentPage :pageCount=pageCount @loadPage="loadPage" />
    </div>
</template>

<script>
    import * as Swal from "sweetalert2";
    import {mapActions} from "vuex";
    import BrandPagination from "@/components/BrandPagination";

    export default {
        name: "BrandList",
        static: {
            itemNumber: 100
        },
        props: {
            items: Array,
            type: String
        },
        components: {
            BrandPagination
        },
        data() {
            return {
                search: '',
                currentPage: 1,
                pageCount: 0,
                sortedItems: [],
                imgURL: process.env.VUE_APP_S3_URL,
            }
        },
        watch: {
            items: function() {
                this.getSortedItem()
            }
        },
        methods: {
            ...mapActions('brand', [
                'deleteBrand',
                'deleteMarketplace'
            ]),

            //Load page and sort content
            countPages() {
                this.pageCount = Math.ceil(this.sortedItems.length/this.$options.static.itemNumber)
            },

            getSortedItem() {
                if (this.search == "") {
                    this.sortedItems = this.items
                } else {
                    this.sortedItems = this.items.filter(c => c.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1);
                }
                this.countPages()
                this.currentPage = 1
            },

            getOnePage() {
                return this.sortedItems.slice((this.currentPage-1)*this.$options.static.itemNumber, this.currentPage*this.$options.static.itemNumber);
            },

            loadPage(id) {
                this.currentPage = id
            },

            //User Interactions

            itemSelect(i){
                window.scrollTo(0, 0);
                this.$emit("edit-item", JSON.parse(JSON.stringify(i)));
            },

            removeItem(i){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        if (this.type === "brands"){
                            this.deleteBrand(i)
                            .then(() => {
                                Swal.fire(
                                    'Deleted!',
                                    'The brand have been deleted',
                                    'success'
                                )
                            });
                        }else{
                            this.deleteMarketplace(i)
                            .then(() => {
                                Swal.fire(
                                    'Deleted!',
                                    'The marketplace have been deleted',
                                    'success'
                                )
                            });
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">

    .search{
        display: block;
        margin-top: 40px;
        width: 50%;
    }

    .item-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-top: 20px;
        padding: 0 20px;

        .item-item{
            position: relative;
            width: 250px;
            margin: 5px;
            border: 2px solid var(--main-green);
            border-radius: 5px;
            padding: 5px 0;
            text-align: center;

            .close-btn{
                font-size: 8px;
                position: absolute;
                color: #fff;
                z-index: 9
            }

            .logo{
                display: inline-block;
                width: 30px;
                height: 30px;
                margin: 5px auto;
                border: 1px solid #bbb;
                border-radius: 50%;
                overflow: hidden;
                vertical-align: middle;

                img{
                    width: 100%;
                }
            }

            p{
                display: inline-block;
                margin: 2px;
                height: 32px;
            }

            .actions{
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;

                .green-btn{
                    font-size: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 35px;
                    width: 35px;
                    margin: auto;
                    padding: 0;
                    border-radius: 50%;
                    text-decoration: none;
                }
            }
        }
    }
</style>
